import { render, staticRenderFns } from "./userPersonalInfo.vue?vue&type=template&id=1c71db42&scoped=true&"
import script from "./userPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./userPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./userPersonalInfo.vue?vue&type=style&index=0&id=1c71db42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71db42",
  null
  
)

export default component.exports